<template>
  <p>
    Материалы, которые могут быть полезны:
  </p>

  <ul class="marked-ul">
    <li>
      Как писать запросы к нейросети <a href="https://craftum.com/blog/promts-dlya-nejrosetej/" target="_blank">https://craftum.com/blog/promts-dlya-nejrosetej/</a>
    </li>
    <li>Бесплатный курс по работе с нейросетями от Тинькофф <a href="https://journal.tinkoff.ru/pro/ai/" target="_blank">https://journal.tinkoff.ru/pro/ai/</a></li>
    <li>Задать вопрос в нашей группе в <a href="https://t.me/+H1iL8MHnsaQ1OWU6">telegram</a>, пишите - поможем</li>
  </ul>
</template>